export default {
  loadingSnackbar: {
    visible: false,
    text: '',
    uploadPercentage: 0
  },
  infoSnackbar: {
    visible: false,
    text: '',
    timeout: 5000,
    hasAction: false,
    link: ''
  },
  reportSnackbar: {
    visible: false,
    errorData: {},
    timeout: 5000,
  },
}
